import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const reviews = [
  {
    name: "Mr.Aman Diwakar",
    country: "United States",
    image: "/img/skyline-team-1.jpg", // Update with relevant images
    rating: 5,
    review: "Skyline Cabs made my travel experience amazing! The ride was smooth, and the driver was courteous. Definitely my go-to service!"
  },
  {
    name: "Mr. Kunal M. Thakur",
    country: "India",
    image: "/img/skyline-team-2.jpg", // Update with relevant images
    rating: 5,
    review: "Exceptional service! The booking was easy, the ride was comfortable, and I felt safe throughout. Highly recommended for anyone in need of a reliable cab service."
  },
  {
    name: "Miss. Divya Talwar",
    country: "United States",
    image: "/img/skyline-team-3.jpg", // Update with relevant images
    rating: 5,
    review: "I have used several cab services, but Skyline Cabs stands out. Professional drivers, affordable rates, and excellent customer service."
  },
  {
    name: "Mr. Karan Maheshwari",
    country: "India",
    image: "/img/skyline-team-4.jpg", // Update with relevant images
    rating: 5,
    review: "Skyline Cabs provides a smooth, stress-free ride. The vehicles are always well-maintained, and the drivers are always on time. Will definitely use again!"
  },
  {
    name: "Miss. Ritika Mathur",
    country: "United States",
    image: "/img/skyline-team-5.jpg", // Update with relevant images
    rating: 5,
    review: "Skyline Cabs made my trip hassle-free. The booking system was simple, and the service was impeccable. I would recommend it to anyone looking for quality transport."
  }
];

const ReviewCard = ({ name, country, image, rating, review }) => (
  <div className="review-card p-3">
    <div className="card border-0 shadow rounded-4 text-center p-4 h-100">
      <h6 className="fw-bold">{name}</h6>

      <div className="mb-2">
        {[...Array(rating)].map((_, i) => (
          <i key={i} className="fa-solid fa-star text-warning me-1"></i>
        ))}
      </div>
      <p className="text-muted fst-italic">"{review}"</p>
    </div>
  </div>
);

const Testimonialsabout = () => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3500,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  return (
    <section
      className="py-5"
      style={{ background: "url(/img/reviewbg.png) no-repeat center center / cover" }}
    >
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">What Our Customers Say About Skyline Cabs</h2>
          <p className="text-muted">Here’s what our happy customers have to say about their Skyline Cabs experience!</p>
        </div>
        <Slider {...settings}>
          {reviews.map((item, idx) => (
            <ReviewCard key={idx} {...item} />
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Testimonialsabout;
